/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1ArtifactEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ARTIFACT_EVENT_ENTITY_NAME = 'ixm.userauth.v1.ArtifactEvent';
export const ixmUserauthV1ArtifactEventEntity = new schema.Entity<IxmUserauthV1ArtifactEvent>(IXM_USERAUTH_V1_ARTIFACT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1ArtifactEvent) => `${entity.metadata?.eventId}` });

